import React from "react";
import { PlayGameMeta } from "../core";

interface MiniGameContainerProps {
  game: PlayGameMeta;
  children?: React.ReactNode;
  onBack?: () => void;
}

const badgeClass =
  "text-[11px] px-2 py-0.5 rounded-full border bg-white dark:bg-slate-900 dark:border-slate-700";

const MiniGameContainer: React.FC<MiniGameContainerProps> = ({ game, children, onBack }) => {
  return (
    <div className="max-w-2xl mx-auto mm-surface p-5 space-y-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">Mini-jeu</p>
          <h2 className="text-xl font-semibold">{game.title}</h2>
          <p className="text-sm text-slate-600 dark:text-slate-300">{game.description}</p>
          <div className="flex gap-2 mt-2 flex-wrap text-xs text-slate-600 dark:text-slate-300">
            <span className={badgeClass}>Catégorie : {game.category}</span>
            <span className={badgeClass}>Difficulté : {game.difficulty}</span>
            {game.estimatedDurationMinutes && (
              <span className={badgeClass}>{game.estimatedDurationMinutes} min</span>
            )}
          </div>
        </div>
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="text-sm px-3 py-1.5 rounded-lg border bg-white dark:bg-slate-900 dark:border-slate-700"
          >
            Retour
          </button>
        )}
      </div>

      <div className="rounded-xl border border-dashed border-slate-300 dark:border-slate-700 p-3 bg-white dark:bg-slate-900">
        {children || <p className="text-sm text-slate-500">Mini-jeu à afficher ici.</p>}
      </div>
    </div>
  );
};

export default MiniGameContainer;
